import { render, staticRenderFns } from "./EditorSubpage.vue?vue&type=template&id=20e6b86f&"
import script from "./EditorSubpage.vue?vue&type=script&lang=js&"
export * from "./EditorSubpage.vue?vue&type=script&lang=js&"
import style0 from "./EditorSubpage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports